<template>
    <sys-register-base
        :loading="loading"
        @onSave="save"
        :model.sync="model"
        :title="title"
        icon="mdi-grid"
        v-bind:show.sync="dialog"
        maxWidth="90%"
    >
        
        <template v-slot:tools>

            <v-tooltip v-if="tab == 1 && model.id" bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn :disabled="disableSaveDisciplines" :loading="loadingSaveDisciplines" color="success darken-1" icon @click.prevent.stop="updateDisciplines()" v-bind="attrs" v-on="on"><v-icon>mdi-content-save-edit-outline</v-icon></v-btn>
                </template>
                <span> Salvar alterações </span>
            </v-tooltip>

        </template>

        <template v-slot:form>
            <v-tabs class="ma-0" v-model="tab">
                <v-tab key="main">Dados</v-tab>
                <v-tab key="disciplines">Disciplinas</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab" >
                <v-tab-item key="main">
                    <v-container>
                    <v-row>
                        <v-col cols="12" sm="8">
                            <sys-select-course
                                    :model.sync="model.course_id"
                                    :error="errors.course_id && errors.length > 0"  
                                    :errors="errors.course_id"
                                    label="Curso*"
                                    autoComplete
                                />
                        </v-col>
                         <v-col cols="12" sm="4">
                            <sys-select-curriculum-category
                                :model.sync="model.curriculum_category_id"
                                :error="errors.length > 0"  
                                :errors="errors.curriculum_category_id"
                                label="Categoria*"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="7">
                            <v-text-field dense autofocus :error="!!errors.name" :error-messages="errors.name" v-model="model.name" label="Nome/Sigla*"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <sys-select-frequency
                                :model.sync="model.frequency_id"
                                :error="errors.length > 0"  
                                :errors="errors.frequency_id"
                                label="Periodicidade*"
                                dense
                            />
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field 
                                dense 
                                :error="!!errors.number_modules" 
                                :error-messages="errors.number_modules" 
                                v-model="model.number_modules" 
                                label="Períodos*"
                            >
                                 <template v-slot:append>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn :disabled="model.number_modules < 1 || model.number_modules > 24" v-bind="attrs" v-on="on" small icon @click.prevent.stop="loadSequencies()">
                                                <v-icon btn color="green darken-1">mdi-flash</v-icon>
                                            </v-btn>
                                        </template>
                                            <span>
                                                Carregar Períodos
                                            </span>
                                    </v-tooltip>
                                </template>
                            
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <sys-select-campus
                                :model.sync="model.campuses"
                                :error="errors.length > 0"  
                                :errors="errors.campuses"
                                label="Campus"
                                multiple
                                dense
                            />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <sys-select-curriculum-status
                                :model.sync="model.curriculum_status_id"
                                :error="errors.length > 0"  
                                :errors="errors.curriculum_status_id"
                                label="Status*"
                                dense
                            />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <sys-select-curriculum-regime
                                :model.sync="model.curriculum_regime_id"
                                :error="errors.length > 0"  
                                :errors="errors.curriculum_regime_id"
                                label="Regime*"
                                dense
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="3">
                            <v-text-field dense :error="!!errors.year" :error-messages="errors.year" v-model="model.year" label="Ano Ingresso"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field dense :error="!!errors.period" :error-messages="errors.period" v-model="model.period" label="Semestre Ingresso"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field dense :error="!!errors.workload" :error-messages="errors.workload" v-model="model.workload" label="Carga Horária"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <s-text-field dense code :error-messages="errors.code" v-model="model.code" label="Código"/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-textarea
                                :error="!!errors.description" 
                                :error-messages="errors.description" 
                                v-model="model.description" 
                                label="Descrição"
                                :counter="255"
                                :rules="[v => (!v || v.length <= 255) || 'Máximo de 255 caracteres atingido']"
                                outlined
                            />
                        </v-col>
                    </v-row>
                </v-container>
                </v-tab-item>
                <v-tab-item key="disciplines">
                    <v-row no-gutters class="matrix-split">

                        <!-- ============ SIDEBAR: lista de períodos ============ -->
                        <v-col cols="12" sm="4" md="3" class="matrix-sidebar">
                            <div class="matrix-sidebar__header pa-3">
                                <div class="d-flex align-center mb-2">
                                    <v-icon left small>mdi-format-list-numbered</v-icon>
                                    <strong>Períodos</strong>
                                    <v-spacer />
                                    <v-tooltip v-if="model.number_modules" bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon x-small v-bind="attrs" v-on="on" @click.prevent.stop="loadSequencies()">
                                                <v-icon small color="primary">mdi-refresh</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Recarregar a partir do nº de períodos da matriz</span>
                                    </v-tooltip>
                                </div>
                                <v-text-field
                                    v-model="sequencySearch"
                                    placeholder="Buscar período / disciplina…"
                                    prepend-inner-icon="mdi-magnify"
                                    clearable
                                    dense
                                    outlined
                                    hide-details
                                />
                            </div>
                            <div class="matrix-sidebar__list">
                                <v-list dense nav>
                                    <v-list-item
                                        v-for="sequency in filteredSequencies"
                                        :key="sequency.curriculum_sequency_id"
                                        :class="{ 'matrix-period-item--active': selectedSequencyId === sequency.curriculum_sequency_id }"
                                        class="matrix-period-item"
                                        @click="selectedSequencyId = sequency.curriculum_sequency_id"
                                    >
                                        <v-list-item-avatar class="period-avatar">
                                            <span v-if="sequency.sequency.id != 99">{{ sequency.sequency.id }}º</span>
                                            <v-icon v-else small>mdi-puzzle</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <span v-if="sequency.sequency.id == 99">{{ sequency.sequency.name }}</span>
                                                <span v-else-if="sequency.initials">{{ sequency.initials }}</span>
                                                <span v-else class="grey--text">Período {{ sequency.sequency.id }}</span>
                                            </v-list-item-title>
                                            <v-list-item-subtitle v-if="sequency.description">
                                                {{ sequency.description }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-chip
                                                x-small
                                                label
                                                :outlined="!sequency.sequencyDisciplines.length"
                                                :color="sequency.sequencyDisciplines.length ? 'primary' : ''"
                                            >
                                                {{ sequency.sequencyDisciplines.length }}
                                            </v-chip>
                                        </v-list-item-action>
                                    </v-list-item>
                                    <div v-if="!filteredSequencies.length" class="text-caption grey--text text-center pa-4">
                                        Nenhum período encontrado.
                                    </div>
                                </v-list>
                            </div>
                        </v-col>

                        <!-- ============ EDITOR: período selecionado ============ -->
                        <v-col cols="12" sm="8" md="9" class="matrix-editor pa-0">
                            <div v-if="!currentSequency" class="text-center grey--text py-12">
                                <v-icon large color="grey lighten-1">mdi-arrow-left-circle-outline</v-icon>
                                <div class="mt-2">Selecione um período à esquerda para editar suas disciplinas.</div>
                            </div>

                            <template v-else>
                                <!-- Cabeçalho do período (sticky) -->
                                <div class="matrix-editor__head pa-3">
                                <div class="d-flex align-center mb-3">
                                    <v-avatar size="40" color="primary" class="white--text mr-3 font-weight-bold">
                                        <span v-if="currentSequency.sequency.id != 99">{{ currentSequency.sequency.id }}º</span>
                                        <v-icon v-else small color="white">mdi-puzzle</v-icon>
                                    </v-avatar>
                                    <div class="flex-grow-1">
                                        <div class="text-subtitle-1 font-weight-bold">
                                            <span v-if="currentSequency.sequency.id == 99">{{ currentSequency.sequency.name }}</span>
                                            <span v-else>{{ currentSequency.sequency.id }}º Período</span>
                                        </div>
                                        <div class="text-caption grey--text">
                                            {{ currentSequency.sequencyDisciplines.length }} disciplina(s)
                                        </div>
                                    </div>
                                    <v-btn small color="primary" depressed @click.prevent.stop="addItem(currentSequency, false)">
                                        <v-icon left small>mdi-plus</v-icon>
                                        Adicionar disciplina
                                    </v-btn>
                                </div>

                                <v-row v-if="currentSequency.sequency.id != 99" dense class="mb-1">
                                    <v-col cols="12" md="4">
                                        <v-text-field
                                            v-model="currentSequency.initials"
                                            label="Módulo (sigla curta)"
                                            outlined
                                            dense
                                            hide-details
                                            @input="disableSaveDisciplines = false"
                                        />
                                    </v-col>
                                    <v-col cols="12" md="8">
                                        <v-text-field
                                            v-model="currentSequency.description"
                                            label="Descrição do período"
                                            outlined
                                            dense
                                            hide-details
                                            @input="disableSaveDisciplines = false"
                                        />
                                    </v-col>
                                    <v-col cols="12">
                                        <v-autocomplete
                                            :value="currentSequency.required_sequencies || []"
                                            @input="setRequiredSequencies(currentSequency, $event)"
                                            :items="getOtherSequencies(currentSequency)"
                                            :item-text="seqLabel"
                                            item-value="id"
                                            multiple
                                            chips
                                            small-chips
                                            deletable-chips
                                            dense
                                            outlined
                                            hide-details
                                            label="Pré-requisitos de ciclo"
                                            placeholder="Períodos que precisam estar 100% cursados antes deste"
                                            prepend-inner-icon="mdi-link-variant"
                                        />
                                    </v-col>
                                </v-row>

                                </div>

                                <!-- Body com scroll próprio -->
                                <div class="matrix-editor__body px-3 pb-3">
                                <!-- Tabela de disciplinas do período -->
                                <v-data-table
                                    :headers="headers"
                                    :items="currentSequency.sequencyDisciplines"
                                    sort-by="discipline.name"
                                    hide-default-footer
                                    :items-per-page="200"
                                    no-data-text="Nenhuma disciplina vinculada — clique em 'Adicionar disciplina'"
                                    class="elevation-0 matrix-disciplines"
                                    dense
                                >
                                    <template v-slot:item.discipline="{ item }">
                                        <div class="font-weight-medium">{{ item.discipline.name_complete }}</div>
                                        <small v-if="item.discipline.code" class="grey--text">[{{ item.discipline.code }}]</small>
                                    </template>

                                    <template v-slot:item.grid_category_id="{ item }">
                                        <sys-select-grid-category
                                            :model.sync="item.grid_category_id"
                                            :error="errors.length > 0"
                                            :errors="errors.grid_category_id"
                                            itemText="initials"
                                            clearable
                                            label=""
                                            @input="disableSaveDisciplines = false"
                                        />
                                    </template>

                                    <template v-slot:item.prerequisites="{ item }">
                                        <div>
                                            <div
                                                v-if="(item.prerequisites_global || []).length"
                                                class="d-flex flex-wrap mb-1"
                                                style="gap: 4px"
                                            >
                                                <v-tooltip
                                                    v-for="gId in item.prerequisites_global || []"
                                                    :key="'g-' + gId"
                                                    bottom
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-chip
                                                            x-small
                                                            label
                                                            :class="{ 'global-prereq-off': isGlobalDisabled(item, gId) }"
                                                            :color="isGlobalDisabled(item, gId) ? 'grey lighten-3' : 'indigo lighten-4'"
                                                            :close="!isGlobalDisabled(item, gId)"
                                                            close-icon="mdi-close-circle"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            @click:close="toggleGlobalDisabled(item, gId)"
                                                        >
                                                            <v-icon x-small left>mdi-link-variant</v-icon>
                                                            {{ getDisciplineLabel(gId) }}
                                                            <v-icon
                                                                v-if="isGlobalDisabled(item, gId)"
                                                                x-small
                                                                right
                                                                @click.stop="toggleGlobalDisabled(item, gId)"
                                                            >
                                                                mdi-restore
                                                            </v-icon>
                                                        </v-chip>
                                                    </template>
                                                    <span>
                                                        Herdado da disciplina ·
                                                        {{ isGlobalDisabled(item, gId) ? 'desativado nesta matriz (clique no ícone para reativar)' : 'clique no X para desativar nesta matriz' }}
                                                    </span>
                                                </v-tooltip>
                                            </div>
                                            <v-autocomplete
                                                :value="item.prerequisites || []"
                                                @input="setPrerequisites(item, $event)"
                                                :items="getPrerequisiteOptions(item)"
                                                item-text="discipline.name_complete"
                                                item-value="discipline_id"
                                                multiple
                                                chips
                                                small-chips
                                                deletable-chips
                                                dense
                                                hide-details
                                                placeholder="Adicionar pré-requisito desta matriz"
                                                :menu-props="{ maxHeight: 300 }"
                                            />
                                        </div>
                                    </template>

                                    <template v-slot:item.actions="{ item }">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon x-small color="error" v-bind="attrs" v-on="on" @click="showDeleteItem(currentSequency, item)">
                                                    <v-icon small>mdi-delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Remover disciplina deste período</span>
                                        </v-tooltip>
                                    </template>
                                </v-data-table>
                                </div>
                            </template>
                        </v-col>
                    </v-row>
                </v-tab-item>
            </v-tabs-items>
           
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>

            <sys-find-discipline 
                showAdd 
                showSelect
                :singleSelect="false" 
                @onSelect="selectDiscipline($event)" 
                :show.sync="dialogAddDiscipline"
            />

            <emc-alert-modal text="Deseja excluir a disciplina?" v-bind:show.sync="showDelete">
                <template v-slot:actions>
                    <v-btn color="error" @click.prevent.stop="deleteItem()" >Excluir <v-icon right dark>mdi-delete</v-icon></v-btn>
                </template>
            </emc-alert-modal>

        </template>
    </sys-register-base>
</template>

<style scoped>
/* Split de matriz: sidebar (períodos) + editor (período selecionado).
   Altura calculada pra usar quase todo o viewport do dialog, com scroll
   interno em vez de scroll na página toda. */
.matrix-split {
    height: calc(100vh - 240px);
    min-height: 480px;
    border-top: 1px solid #E5E7EB;
    overflow: hidden;
}
.matrix-sidebar {
    background: #FAFAFA;
    border-right: 1px solid #E5E7EB;
    display: flex;
    flex-direction: column;
    height: 100%;
}
.matrix-sidebar__header {
    border-bottom: 1px solid #E5E7EB;
    background: white;
    flex-shrink: 0;
}
.matrix-sidebar__list {
    flex: 1 1 auto;
    overflow-y: auto;
    min-height: 0;
}
.matrix-period-item {
    border-left: 3px solid transparent;
    border-radius: 0 !important;
    margin: 0 !important;
    padding-right: 8px;
}
.matrix-period-item:hover {
    background: #EEF2FF;
}
.matrix-period-item--active {
    background: #EEF2FF !important;
    border-left-color: var(--v-primary-base, #1976D2);
}
.matrix-period-item--active >>> .v-list-item__title {
    font-weight: 600;
    color: var(--v-primary-base, #1976D2);
}
.period-avatar {
    background: rgba(25, 118, 210, 0.12) !important;
    color: var(--v-primary-base, #1976D2);
    font-weight: 700;
    font-size: 13px;
    min-width: 32px !important;
    width: 32px !important;
    height: 32px !important;
}
.matrix-editor {
    background: white;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
}
.matrix-editor__head {
    flex-shrink: 0;
}
.matrix-editor__body {
    flex: 1 1 auto;
    overflow-y: auto;
    min-height: 0;
}
/* Compacta as células do select de categoria/inputs pra não tomar tanta altura. */
.matrix-disciplines >>> .v-data-table__wrapper {
    overflow: visible;
}
.matrix-disciplines >>> td {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
}
.matrix-disciplines >>> .v-input--dense {
    margin-top: 0 !important;
}

</style>

<script>

import { mapActions, mapState } from 'vuex'
export default {
    name: "SysRegisterCurriculum",
    data: (vm) => ({
        dialog: false,
        tab: 0,
        renderComponent: true,
        panel: null,
        selectedSequencyId: null,
        sequencySearch: '',
        dialogAddDiscipline: false,
        showDelete: false,
        selectedSequency: null,
        selectedItem: null,
        sequencies: [],
        disableSaveDisciplines: true,
        loadingSaveDisciplines: false,
        error: false,
        errors: {},
        message: '',
        loading: false,
        headers: [
            { text: 'Disciplina',    value: 'discipline',       sortable: false, width: '38%'},
            { text: 'Categoria',     value: 'grid_category_id', sortable: false, width: '20%'},
            { text: 'Pré-requisitos', value: 'prerequisites',   sortable: false, width: '40%'},
            { text: 'Ações',         value: 'actions',          sortable: false, width: '2%'}
    ]
        
    }),
    created(){
       this.getSequencies();
    },

    computed: {
      ...mapState('auth', ['acesso']),

      filteredSequencies(){
          const list = (this.model && this.model.sequencies) || [];
          const q = (this.sequencySearch || '').toString().trim().toLowerCase();
          if (!q) return list;
          return list.filter((seq) => {
              const baseLabel = ((seq.sequency && seq.sequency.id == 99 ? seq.sequency.name : (seq.sequency && seq.sequency.id + 'º')) || '').toLowerCase();
              const initials = (seq.initials || '').toLowerCase();
              const desc = (seq.description || '').toLowerCase();
              if (baseLabel.includes(q) || initials.includes(q) || desc.includes(q)) return true;
              // Busca também nos nomes das disciplinas
              return (seq.sequencyDisciplines || []).some(sd => {
                  const d = sd.discipline || {};
                  return (d.name_complete || '').toLowerCase().includes(q)
                      || (d.name || '').toLowerCase().includes(q)
                      || (d.code || '').toLowerCase().includes(q);
              });
          });
      },

      currentSequency(){
          const list = (this.model && this.model.sequencies) || [];
          return list.find(s => s.curriculum_sequency_id === this.selectedSequencyId) || null;
      },
    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {

            this.dialog = show_new;

            if(show_new){

                this.error = false;
                this.errors = {};
                this.panel = null;
                this.tab = 0;
                this.disableSaveDisciplines = true;
                this.sequencySearch = '';
                this.selectedSequencyId = null;

                if(!this.model.id){
                    this.model.curriculum_status_id = 3;
                    this.model.sequencies = [];
                }

            }
        },

        tab(newTab) {
            // Ao entrar na aba Disciplinas, seleciona o 1º período automaticamente.
            if (newTab === 1 && !this.selectedSequencyId && this.model && Array.isArray(this.model.sequencies) && this.model.sequencies.length) {
                this.selectedSequencyId = this.model.sequencies[0].curriculum_sequency_id;
            }
        },
        
    },
    props: {
        model: {
            default: null
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-alert"
        },
        title: {
            type: String,
            default: "Matriz Curricular"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('curriculum', [
            'ActionUpdateCurriculum',
            'ActionUpdateCurriculumDisciplines',
            'ActionCreateCurriculum',
            'ActionFindCurriculumSequencies',
            'ActionDisableGlobalPrereq',
            'ActionEnableGlobalPrereq',
        ]),

        save(edit)
        {
            this.error = false;
            this.message = '';
            this.loading = true;

            Object.assign(this.model, {
                institution_id: this.acesso.instituicao.id,
                changeDisciplines: !this.disableSaveDisciplines
            });

            if(edit) {
                this.ActionUpdateCurriculum(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted');
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                     this.loading = false;
                     this.disableSaveDisciplines = true;
                })
            } else {
                this.ActionCreateCurriculum(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted', res.data);
                })
                .catch((error) =>{
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                   this.loading = false;
                })

            }
        },

        updateDisciplines()
        {
            this.error = false;
            this.message = '';
            this.loadingSaveDisciplines = true;

            Object.assign(this.model, {institution_id: this.acesso.instituicao.id});

            
                this.ActionUpdateCurriculumDisciplines(this.model)
                .then((res) => {
                    this.message = res.message;
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                     this.loadingSaveDisciplines = false;
                     this.disableSaveDisciplines = true;
                })
        },

        getSequencies() {

            this.ActionFindCurriculumSequencies()
                .then((res) => {
                    this.sequencies = res.data;
                })
                .finally(() => {
                    
                });
        },

        addItem(item){
            
            this.selectedSequency = item;
            this.dialogAddDiscipline = true;
            

        },

        selectDiscipline(items){

            if(this.selectedSequency && this.selectedSequency.sequencyDisciplines){

                items.forEach(discipline => {
                    var find = this.selectedSequency.sequencyDisciplines.find(i => i.discipline_id == discipline.id);

                    if(!find){
                            this.selectedSequency.sequencyDisciplines.push(
                                {
                                    discipline_id:           discipline.id,
                                    grid_category_id:        null,
                                    discipline:              { id: discipline.id, code: discipline.code, name: discipline.name, name_complete: discipline.name_complete, work_load: discipline.work_load },
                                    category:                null,
                                    prerequisites:           [],
                                    prerequisites_global:    [],
                                    disabled_global_prereqs: [],
                                }
                            );
                    }
                });

                this.dialogAddDiscipline = false;
                this.disableSaveDisciplines = false;
            }

            this.forceRerender();
        },

        showDeleteItem(sequency, item){

            this.selectedSequency = sequency;
            this.selectedItem = item;
            this.showDelete = true;

        },

        deleteItem(){
            if(this.selectedSequency && this.selectedItem){
                var index = this.selectedSequency.sequencyDisciplines.indexOf(this.selectedItem);
                this.selectedSequency.sequencyDisciplines.splice(index, 1);
                this.showDelete = false;
                this.disableSaveDisciplines = false;
            }
        },

        getPrerequisiteOptions(item){
            // Lista todas as disciplinas vinculadas à matriz, exceto a própria.
            const options = [];
            const seen = {};

            if(this.model && Array.isArray(this.model.sequencies)){
                this.model.sequencies.forEach((seq) => {
                    (seq.sequencyDisciplines || []).forEach((sd) => {
                        if(!sd || !sd.discipline_id || sd.discipline_id === item.discipline_id){
                            return;
                        }
                        if(seen[sd.discipline_id]) return;
                        seen[sd.discipline_id] = true;
                        options.push(sd);
                    });
                });
            }

            return options;
        },

        setPrerequisites(item, value){
            this.$set(item, 'prerequisites', value || []);
            this.disableSaveDisciplines = false;
        },

        getDisciplineLabel(disciplineId){
            // Procura o nome da disciplina entre as carregadas na matriz.
            if (this.model && Array.isArray(this.model.sequencies)) {
                for (const seq of this.model.sequencies) {
                    for (const sd of (seq.sequencyDisciplines || [])) {
                        if (sd.discipline_id === disciplineId) {
                            const d = sd.discipline || {};
                            return d.name_complete || d.name || ('Disciplina #' + disciplineId);
                        }
                    }
                }
            }
            return 'Disciplina #' + disciplineId;
        },

        isGlobalDisabled(item, requiredId){
            return (item.disabled_global_prereqs || []).includes(requiredId);
        },

        async toggleGlobalDisabled(item, requiredId){
            if (!this.model.id) return;
            const wasDisabled = (item.disabled_global_prereqs || []).includes(requiredId);
            // Otimismo: atualiza local primeiro pra UI responder na hora.
            const list = [...(item.disabled_global_prereqs || [])];
            if (wasDisabled) list.splice(list.indexOf(requiredId), 1);
            else list.push(requiredId);
            this.$set(item, 'disabled_global_prereqs', list);

            try {
                if (wasDisabled) {
                    await this.ActionEnableGlobalPrereq({
                        id: this.model.id,
                        disciplineId: item.discipline_id,
                        requiredId,
                    });
                } else {
                    await this.ActionDisableGlobalPrereq({
                        id: this.model.id,
                        discipline_id: item.discipline_id,
                        required_discipline_id: requiredId,
                    });
                }
                this.message = wasDisabled ? 'Pré-requisito reativado' : 'Pré-requisito desativado';
                this.error = false;
            } catch (e) {
                // Reverte em caso de erro.
                this.$set(item, 'disabled_global_prereqs', wasDisabled
                    ? [...list, requiredId]
                    : list.filter(x => x !== requiredId)
                );
                this.error = true;
                this.message = (e && e.message) || 'Falha ao atualizar pré-requisito';
            }
        },

        getOtherSequencies(sequency){
            if (!this.model || !Array.isArray(this.model.sequencies)) return [];
            return this.model.sequencies.filter(s => s.id && s.id !== sequency.id && s.sequency && s.sequency.id !== 99);
        },

        seqLabel(s){
            const base = s.sequency && s.sequency.id ? (s.sequency.id + 'º período') : 'Período';
            const extra = s.description ? ` — ${s.description}` : '';
            return base + extra;
        },

        setRequiredSequencies(sequency, value){
            this.$set(sequency, 'required_sequencies', value || []);
            this.disableSaveDisciplines = false;
        },

        loadSequencies(){

            var array = [];
            var atividades = null;

            this.model.sequencies.forEach(el => {
                
                if(el.curriculum_sequency_id != 99){
                    
                    if(el.curriculum_sequency_id <= this.model.number_modules){
                        array.push(el);
                    }
                }else{
                    atividades = el;
                }

            });

            this.sequencies.forEach(s => {

                var find = null;

                if(this.model.sequencies.length > 0){
                    find = this.model.sequencies.find(i => i.curriculum_sequency_id == s.id);
                }
                
                if(!find && s.id <= this.model.number_modules){
                    
                    var sequency = {
                        curriculum_id:          this.model.id ? this.model.id : 0,
                        curriculum_sequency_id: s.id,
                        initials: '',
                        description: '',
                        sequencyDisciplines: [],
                        sequency: {
                            id: s.id,
                            name: s.name
                        }
                    }

                    if(s.id != 99){
                        array.push(sequency);
                    }else{
                        if(!atividades){
                            atividades = sequency;
                        }
                    }
                }

            });

            if(atividades){
                array.push(atividades);
            }else{
                
                var atividade = this.sequencies.find(i => i.id == 99);

                var sequency = {
                    curriculum_id:          this.model.id ? this.model.id : 0,
                    curriculum_sequency_id: atividade.id,
                    initials: '',
                    description: '',
                    sequencyDisciplines: [],
                    sequency: {
                        id:     atividade.id,
                        name:   atividade.name
                    }
                }

                array.push(sequency);
            }

            array.sort((a,b) => (a.curriculum_sequency_id > b.curriculum_sequency_id) ? 1 : ((b.curriculum_sequency_id > a.curriculum_sequency_id) ? -1 : 0));

            if(array.length != this.model.sequencies.length){
                this.model.sequencies = array;
                this.forceRerender();
            }

        },

        forceRerender () {
            this.renderComponent = false;

            this.$nextTick(() => {
                this.renderComponent = true;
            });
      },
      
    }
}
</script>